/**
 * Directive: formsCardTypes
 */
angular.module('acme.common.directive.forms.cardTypes', [
  'acme.common.service.themesHelper'
])
.directive('formsCardTypes', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/forms/cardTypes/cardTypes.tpl.html',
      scope: {},
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', 'ThemesHelperService', function($scope, ThemesHelperService) {

        $scope.formsCardTypes = {

          types: [
            {
              name: 'visa',
              label: 'Visa'
            },
            {
              name: 'mastercard',
              label: 'Mastercard'
            },
            {
              name: 'discover',
              label: 'Discover'
            }
          ],

          init: function () {

            if (ThemesHelperService.getCompany('allowAMEX')) {
              this.types.push({
                name: 'amex',
                label: 'American Express'
              });
            }

          }

        };

        $scope.formsCardTypes.init();

      }]

    };

}]);